"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "monteviale": {
    "17a3b73a": [{
      "hkey": "ead73623",
      "slug": "bagnara-settecamini",
      "name": "Bagnara-Settecamini",
      "primary": true,
      "skipSearch": false
    }],
    "settecamini": [{
      "hkey": "ead73623",
      "slug": "bagnara-settecamini",
      "name": "Bagnara-Settecamini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6b5bda53": [{
      "hkey": "3c142d69",
      "slug": "monteviale",
      "name": "Monteviale",
      "primary": true,
      "skipSearch": false
    }],
    "delle-mure": [{
      "hkey": "3c142d69",
      "slug": "monteviale",
      "name": "Monteviale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "46f9fff2": [{
      "hkey": "3c142d69",
      "slug": "monteviale",
      "name": "Monteviale",
      "primary": true,
      "skipSearch": false
    }],
    "fornaci": [{
      "hkey": "3c142d69",
      "slug": "monteviale",
      "name": "Monteviale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;